import styled from "styled-components";

export const ContainerError = styled.div`
display: flex;
align-items: center;
flex-direction:column;
margin:0 auto;
width: 100%;
height:100vh;
color:white;
`

export const ImgError = styled.img`
width: 60%;
`